import React from 'react'
import { useTranslation } from 'react-i18next'

const EmptyModal = ({ closeModal, title, content, style, hasFooter }) => {
  const { t } = useTranslation()
  return (
    <div className="modal-content" style={style}>
      <div className="modal-header">
        {title &&
          <h5
            className="modal-title"
          >{title}</h5>
        }
        <button type="button" className="btn-close" aria-label={t('common.close')} onClick={closeModal}></button>
      </div>
      <div className="modal-body">
        {content}
      </div>

      {hasFooter &&
        <div className="modal-footer">
          <button type="button" className="btn btn-outline-primary" onClick={closeModal}>{t('common.close')}</button>
        </div>
      }
    </div>
  )
}

export default EmptyModal
